// extracted by mini-css-extract-plugin
export default {"iconButton":"a5ptBY","external":"b5ptBY","label":"c5ptBY"};